import http from '@/utils/http';

/**
 * 获取列表-tr
 */
export function getList(data) {
    return http({
        url: '/api-lcrm/goal/split/rule/page',
        method: 'post',
        data
    });
};

/**
 * 导入-tr
 */
export function importApi(data) {
    return http({
        url: '/api-lcrm/goal/split/rule/import',
        method: 'post',
        data
    });
};

/**
 * 导出-tr
 */
export function exportApi(data) {
    return http({
        url: '/api-lcrm/goal/split/rule/export',
        method: 'post',
        data
    });
};

/**
 * 删除-tr
 */
export function deleteApi(data) {
    return http({
        url: '/api-lcrm/goal/split/rule/deleteBatch',
        method: 'post',
        data
    });
};
